<app-page-hero
  badge="المشاريع"
  title="تجارة المحاصيل"
  descriptionLine1="استفد من فروق أسعار المحاصيل بين مواسم الحصاد وأوقات الذروة، عبر تعاقدات "
  descriptionLine2="قصيرة الأمد لشراء المحاصيل بكميات كبيرة وتخزينها وبيعها في الوقت المناسب.
الوحدة المتاحة: بالكيلو أو بالطن."
  bgImage="/images/bg.png">
</app-page-hero>
